module.exports = __webpack_public_path__ + "img/Klimpel-Hildebrandt2019.ba1a0091.jpg";